import { observer } from "mobx-react";
import { FC } from "react";
import { Box } from "@mui/material";

import PolicyQuestions from "../components/preChats/PolicyQuestions";
import SidePanelContent from "../components/ui/SidePanelContent";
import Column from "../components/ui/core/Column";
import { useAppStore } from "../hooks/useAppStore";
import { useChatCategoryStore } from "../hooks/useChatCategoryStore";

// Resetting on mount happens inside PolicyQuestions, not here -- child effects run
// before parent effects, so clearing here would race the child's initial
// fetchPolicyResearch() (see PolicyQuestions.tsx's mount effect, and ContractResearchPage.tsx).
export const PolicyQuestionsPage: FC = observer(() => {
  const { sidebarWidth } = useAppStore();
  const { sidePanelWidth, isPoliciesDocumentsDrawerOpen } = useChatCategoryStore();

  return (
    <main
      id="chat-container-ref"
      className="relative grow flex flex-row bg-hex-gray-100 h-[calc(100%-7rem)]"
      style={{ width: `calc(100vw - ${sidebarWidth}px)` }}
    >
      <Column
        sx={{
          height: "100%",
          width: isPoliciesDocumentsDrawerOpen ? `calc(100% - ${sidePanelWidth}%)` : "100%",
          minWidth: 0,
          minHeight: 0,
          overflow: "hidden",
          flexShrink: 0,
          justifyContent: "flex-start",
          alignItems: "stretch",
        }}
      >
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            overflowY: "auto",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            pb: 1.5,
            boxSizing: "border-box",
          }}
        >
          <PolicyQuestions />
        </Box>
      </Column>

      {isPoliciesDocumentsDrawerOpen ? (
        <SidePanelContent
          activePanel="policy"
          position="right"
          editor={{} as any}
          viewer={{} as any}
        />
      ) : null}
    </main>
  );
});
